import ProposalSettingsDC from '../proposalSettings/ProposalSettingsDC';

export const enum DISCOUNT_TYPES {
  VALUE = 'VALUE',
  PERCENT = 'PERCENT',
}
export const enum PriceProposalStatus {
  DRAFT = "DRAFT",
  SENT = "SENT",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  EXPIRED = "EXPIRED",
}

type ProposalRelationsDC = [
  {
    type: 'contact';
    id: string;
  }
];

export default interface ProposalDC {
  uuid: string;
  number: number | null;
  title: string | null;
  client: string;
  subtotal_price: number;
  price_with_discount: number;
  tax_value: number;
  price_with_tax: number;
  status: PriceProposalStatus;
  workspace_id: string;
  description: string | null;
  discount_type: DISCOUNT_TYPES;
  discount_amount: number;
  relations: ProposalRelationsDC;
  items: {
    order: number;
    description: string | null;
    qty: number;
    amount: number;
  }[];
  is_draft: boolean | null;
  not_show: boolean | null;
  sent_at: number | null; // timestamp in seconds or null
  created_at: number | null; // timestamp in seconds or null
  updated_at: number | null; // timestamp in seconds or null
  created_by: string | null;
  updated_by: string | null;
  settings: ProposalSettingsDC;
  // Set by the server once the customer signs through the sign link; never sent back.
  signed_pdf_url?: string | null;
}
